import { useCallback, useRef, useState } from 'react'
import { openDesktopApp } from '~/utils/desktopDeepLink'

export enum DesktopAppLaunchStep {
  Confirm = 'confirm',
  NotOpened = 'notOpened',
}

/**
 * Drives the "Did it open?" flow after a desktop-app launch attempt.
 * `retry` relaunches the last deep link passed to `launch`.
 */
export const useDesktopAppLaunchConfirm = () => {
  const [step, setStep] = useState<DesktopAppLaunchStep | null>(null)
  const lastDeepLinkRef = useRef<string | null>(null)

  const launch = useCallback((deepLink: string) => {
    lastDeepLinkRef.current = deepLink
    openDesktopApp(deepLink)
    setStep(DesktopAppLaunchStep.Confirm)
  }, [])

  const retry = useCallback(() => {
    if (lastDeepLinkRef.current) launch(lastDeepLinkRef.current)
  }, [launch])

  const markNotOpened = useCallback(
    () => setStep(DesktopAppLaunchStep.NotOpened),
    [],
  )

  const close = useCallback(() => setStep(null), [])

  return { step, launch, retry, markNotOpened, close }
}

export type DesktopAppLaunchConfirm = ReturnType<
  typeof useDesktopAppLaunchConfirm
>
